import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import Select from "react-select";
import _ from "lodash";
import Header from "../../../components/Header";
import Firebase from "../../../firebasehelper";
import ButtonSwitcher from "../../../components/ButtonSwitcher";
import EditTicketModal from "../components/EditTicketModal";
import TicketTile from "../components/TicketTile";

import "./index.css";

const buttonsGroup = ["Ticket/task categories", "Top 6 tasks"];

const TicketTypes = () => {
  const location = useLocation();
  const history = useHistory();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [ticketTypes, setTicketTypes] = useState([]);
  const [ticketTypesSettings, setTicketTypesSettings] = useState({});
  const [clickedTicketTypeSetting, setClickedTicketTypeSetting] =
    useState(null);
  const [clickedTicketTypeId, setClickedTicketTypeId] = useState(null);
  const [page, setPage] = useState("Ticket/task categories");
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);

      Firebase.getBrandDataByID(brand, async (brand_data) => {
        if (brand_data) {
          const sectors = await Firebase.getAllSectors();
          console.log("brand_data", brand_data);
          const { sector, ticket_types_settings } = brand_data;
          if (sector) {
            const sectorData = sectors[sector];
            const { ticket_types } = sectorData;
            if (ticket_types) {
              setTicketTypes(ticket_types);
            }
            if (ticket_types_settings)
              setTicketTypesSettings(ticket_types_settings);
          }
          setBrandData(brand_data);
          setLoading(false);
        }
      });
    }
  }, [location]);

  useEffect(() => {
    console.log("ticketTypes", ticketTypes);
  }, [ticketTypes]);

  // --handler
  const handleSwitchBtn = (page) => {
    setPage(page);
  };
  const handleClickTicketTile = (id) => () => {
    const setting = ticketTypesSettings[id];
    setClickedTicketTypeSetting(setting);
    setClickedTicketTypeId(id);
  };
  const handleUpdateSetting = (setting) => {
    const newTicketTypesSettings = _.cloneDeep(ticketTypesSettings);
    newTicketTypesSettings[clickedTicketTypeId] = {
      id: clickedTicketTypeId,
      ...setting,
    };
    Firebase.updateBrandDataById(brand, {
      ticket_types_settings: newTicketTypesSettings,
    });
  };
  const renderTicketsTiles = () => {
    return (
      <div className="ticket-tiles-container">
        {ticketTypes.map((item) => (
          <TicketTile
            {...item}
            {...ticketTypesSettings[item.id]}
            onClick={handleClickTicketTile(item.id)}
          />
        ))}
      </div>
    );
  };
  return (
    <div id="page-container" className="ticket-type-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container">
        <ButtonSwitcher
          buttonsGroup={buttonsGroup}
          currentTab="Ticket/task categories"
          onSwitch={handleSwitchBtn}
          hex={brand_data.hex}
          white={brand_data.white}
        />
        {loading && (
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {!loading && renderTicketsTiles()}
        <EditTicketModal
          ticketTypeSetting={clickedTicketTypeSetting}
          onEdit={handleUpdateSetting}
        />
      </main>
    </div>
  );
};

export default TicketTypes;



// WEBPACK FOOTER //
// ./src/screens/Tasks/TicketTypes/index.js